exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#SidebarMarkerTypes a{text-decoration:none}.addMarkerCategoryButton{margin-left:10px !important;margin-bottom:20px !important}.markerIcon{margin-right:1em;height:auto;width:auto;max-width:30px;max-height:30px}.markerListItem{margin-left:.5em}.categoryList{padding:0;margin-bottom:16px;margin-top:16px;border:1px solid #ededed}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/Menus/MarkerCategoriesMenu/style.scss
// module id = 6197
// module chunks = 0